import API from '../api'
import getUrl from './paths'
import convertPagableData from '../convertPagableData'

export const getlogisticsPrices = (page = 0, size = 10000) =>
	new Promise((resolve, reject) => {
		API.get(getUrl.getlogisticsPrices, { page, size })
			.then((response) => {
				resolve(convertPagableData(response.data))
			})
			.catch((err) => reject(err))
	})

export const getlogisticsPricesById = (enquiryId) =>
	new Promise((resolve, reject) => {
		API.get(getUrl.getlogisticsPricesById, { enquiryId })
			.then((response) => {
				resolve(response.data)
			})
			.catch((err) => reject(err))
	})

export const getLogisticsPricesRangeByPinCodes = (fromPinCode, toPinCode) =>
	new Promise((resolve, reject) => {
		API.get(getUrl.getLogisticsPricesRangeByPinCodes, { fromPinCode, toPinCode })
			.then((response) => {
				resolve(response.data)
			})
			.catch((err) => reject(err))
	})

export const getLogisticsByEnquiryId = (enquiryId, statuses) =>
	new Promise((resolve, reject) => {
		API.get(getUrl.getAllLogsitcsByEnquiryId, { enquiryId, statuses })
			.then((response) => {
				resolve(response.data)
			})
			.catch((error) => {
				reject(error)
			})
	})

export const getLogisticsQuoteById = (logisticsId) =>
	new Promise((resolve, reject) => {
		API.get(getUrl.getLogisticsQuoteById, { logisticsId })
			.then((response) => {
				resolve(response.data)
			})
			.catch((error) => {
				reject(error)
			})
	})

export const getAllLogisticsRequests = (page, size, logisticsStatus, filters) =>
	new Promise((resolve, reject) => {
		API.get(getUrl.getAllLogisticsRequests, { page, size, logisticsStatus, ...filters })
			.then((response) => {
				resolve(convertPagableData(response.data))
			})
			.catch((error) => {
				reject(error)
			})
	})
